import '@babel/polyfill'
import Vue from 'vue'
import './plugins/axios'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import router from './router/'
import store from './store/'
import VeeValidate from 'vee-validate'
import './plugins/vee-validate'
import Vue2Filters from 'vue2-filters'
import currency from 'vue2-filters/src/other/currency'
import VueMoment from 'vue-moment'
import FlagIcon from 'vue-flag-icon'
import moment from 'moment'
import * as Sentry from '@sentry/vue'
import { abilitiesPlugin } from '@casl/vue'
import ability from './plugins/ability'
import '@/styles/main.scss'
import VueCurrencyInput from 'vue-currency-input'

Vue.config.productionTip = false

if (process.env.NODE_ENV === 'production' && process.env.VUE_APP_SENTRY_DSN) {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration()
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.05,

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 0.5,

    trackComponents: true
  })
}

Vue.use(VeeValidate, {
  errorBagName: 'veeErrors',
  fieldsBagName: 'veeFields'
})
Vue.use(Vue2Filters)
Vue.use(VueMoment)
Vue.use(FlagIcon)
Vue.use(abilitiesPlugin, ability)
Vue.use(VueCurrencyInput)

const UNITS = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
const STEP = 1024

function format(value, power) {
  return (value / Math.pow(STEP, power)).toFixed(2) + UNITS[power]
}

Vue.filter('fileSize', function (value) {
  value = parseFloat(value, 10)
  for (var i = 0; i < UNITS.length; i++) {
    if (value < Math.pow(STEP, i)) {
      if (UNITS[i - 1]) {
        return format(value, i - 1)
      }
      return value + UNITS[i]
    }
  }
  return format(value, i - 1)
})

Vue.filter('currency', function (value, currencySymbol, decimalPlaces = 0) {
  return currency(value, currencySymbol, decimalPlaces, {
    symbolOnLeft: true,
    spaceBetweenAmountAndSymbol: true,
    thousandsSeparator: '.',
    decimalSeparator: ','
  })
})

Vue.filter('fromMetric', function (value, unit, decimalPlaces = 0) {
  if (store.state.auth.user && store.state.auth.user.units !== 'imperial') {
    value = Math.round(value * 100) / 100

    return value.toLocaleString('en-US', { maximumFractionDigits: decimalPlaces, minimumFractionDigits: decimalPlaces }) + ' ' + unit
  }

  if (unit === 'm') {
    unit = 'ft'
    value = value * 3.2808399
  }
  if (unit === 'kg') {
    unit = 'lb'
    value = value * 2.2046
  }
  if (unit === 'm2') {
    unit = 'sq'
    value = value * 10.764
  }
  if (unit === 'l') {
    unit = 'gal'
    value = value * 0.21996925
  }

  return value.toLocaleString('en-US', { maximumFractionDigits: decimalPlaces, minimumFractionDigits: decimalPlaces }) + ' ' + unit
})

/**
 * Vue filter to convert the given value to percent.
 * http://jsfiddle.net/bryan_k/qauf3qyh/
 *
 * @param {String} value    The value string.
 * @param {Number} decimals The number of decimal places.
 */
Vue.filter('percentage', function(value, decimals) {
  if (!value) {
    value = 0
  }

  if (!decimals) {
    decimals = 0
  }

  value = value * 100
  value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals)
  value = value + '%'
  return value
})

// authenticate if token is available in local storage
let token = localStorage.getItem('authToken')
let expiresAt = localStorage.getItem('expiresAt')

if (!expiresAt || moment().unix() >= expiresAt) token = null

if (token) {
  store.dispatch('auth/login', { access_token: token })
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
